<div class="backdrop-bg" (mousedown)="isScrollbarClick($event) && onClose()"></div>
<div class="backdrop" (mousedown)="isScrollbarClick($event) && onClose()">
  <div class="downloading-add" (mousedown)="$event.stopPropagation()">
    <div class="edit-bg">
      <div class="d-flex justify-content-between">
        <div [style.background-image]="'url(' + logo + ')'" class="logo"></div>
        <div class="close-button" (mousedown)="onClose()">x</div>
      </div>
      <ng-content></ng-content>
    </div>
  </div>
</div>